module.exports = __webpack_public_path__ + "static/media/west-virginia.93db65d7.png";